/* eslint-disable */
import _, {intersection} from 'lodash'
import routeParams from 'helpers/routeParams'
import getOrgsHierarchyId from 'helpers/getOrgsHierarchyId'
import { ORGANIZATION_HIERARCHY } from 'constants/enums'
import {mapForBulk} from "../../selectors/participants/mapParticipantsForBulk";
import {sameIdsIn} from "../../../utils/array";

const GET_UNITS_LIST = 'dofe-bo/UNIT/GET_UNITS_LIST'
const GET_UNITS_LIST_SUCCESS = 'dofe-bo/UNIT/GET_UNITS_LIST_SUCCESS'
const GET_UNITS_LIST_FAIL = 'dofe-bo/UNIT/GET_UNITS_LIST_FAIL'

const GET_UNIT = 'dofe-bo/UNIT/GET_UNIT'
const GET_UNIT_SUCCESS = 'dofe-bo/UNIT/GET_UNIT_SUCCESS'
const GET_UNIT_FAIL = 'dofe-bo/UNIT/GET_UNIT_FAIL'

const GET_UNITS_CODE_LIST = 'dofe-bo/UNIT/GET_UNITS_CODE_LIST'
const GET_UNITS_CODE_LIST_SUCCESS = 'dofe-bo/UNIT/GET_UNITS_CODE_LIST_SUCCESS'
const GET_UNITS_CODE_LIST_FAIL = 'dofe-bo/UNIT/GET_UNITS_CODE_LIST_FAIL'

const APPROVE_AWARD_UNIT = 'dofe-bo/UNIT/APPROVE_AWARD_UNIT'
const APPROVE_AWARD_UNIT_SUCCESS = 'dofe-bo/UNIT/APPROVE_AWARD_UNIT_SUCCESS'
const APPROVE_AWARD_UNIT_FAIL = 'dofe-bo/UNIT/APPROVE_AWARD_UNIT_FAIL'

const UPDATE_MY_ORGANIZATION = 'dofe-bo/MY_ORGANIZATION/UPDATE_MY_ORGANIZATION'
const UPDATE_MY_ORGANIZATION_SUCCESS =
  'dofe-bo/MY_ORGANIZATION/UPDATE_MY_ORGANIZATION_SUCCESS'
const UPDATE_MY_ORGANIZATION_FAIL =
  'dofe-bo/MY_ORGANIZATION/UPDATE_MY_ORGANIZATION_FAIL'

const REMOVE_ORGANIZATION = 'dofe-bo/MY_ORGANIZATION/REMOVE_ORGANIZATION'
const REMOVE_ORGANIZATION_SUCCESS =
  'dofe-bo/MY_ORGANIZATION/REMOVE_ORGANIZATION_SUCCESS'
const REMOVE_ORGANIZATION_FAIL =
  'dofe-bo/MY_ORGANIZATION/REMOVE_ORGANIZATION_FAIL'

const CHANGE_ORGANIZATION_MODE =
  'dofe-bo/MY_ORGANIZATION/CHANGE_ORGANIZATION_MODE'
const CHANGE_ORGANIZATION_MODE_SUCCESS =
  'dofe-bo/MY_ORGANIZATION/CHANGE_ORGANIZATION_MODE_SUCCESS'
const CHANGE_ORGANIZATION_MODE_FAIL =
  'dofe-bo/MY_ORGANIZATION/CHANGE_ORGANIZATION_MODE_FAIL'

const GET_MY_ORGANIZATION_LEADER =
  'dofe-bo/MY_ORGANIZATION/GET_MY_ORGANIZATION_LEADER'
const GET_MY_ORGANIZATION_LEADER_SUCCESS =
  'dofe-bo/MY_ORGANIZATION/GET_MY_ORGANIZATION_LEADER_SUCCESS'
const GET_MY_ORGANIZATION_LEADER_FAIL =
  'dofe-bo/MY_ORGANIZATION/GET_MY_ORGANIZATION_LEADER_FAIL'
const CHANGE_ORG_AUTH_CONTACT =
  'dofe-bo/MY_ORGANIZATION/CHANGE_ORG_AUTH_CONTACT'
const CHANGE_ORG_AUTH_CONTACT_SUCCESS =
  'dofe-bo/MY_ORGANIZATION/CHANGE_ORG_AUTH_CONTACT_SUCCESS'
const CHANGE_ORG_AUTH_CONTACT_FAIL =
  'dofe-bo/MY_ORGANIZATION/CHANGE_ORG_AUTH_CONTACT_FAIL'

const CHANGE_ORG_COORDINATOR = 'dofe-bo/MY_ORGANIZATION/CHANGE_ORG_COORDINATOR'
const CHANGE_ORG_COORDINATOR_SUCCESS =
  'dofe-bo/MY_ORGANIZATION/CHANGE_ORG_COORDINATOR_SUCCESS'
const CHANGE_ORG_COORDINATOR_FAIL =
  'dofe-bo/MY_ORGANIZATION/CHANGE_ORG_COORDINATOR_FAIL'

const REMOVE_ORG_COORDINATOR = 'dofe-bo/MY_ORGANIZATION/REMOVE_ORG_COORDINATOR'
const REMOVE_ORG_COORDINATOR_SUCCESS =
  'dofe-bo/MY_ORGANIZATION/REMOVE_ORG_COORDINATOR_SUCCESS'
const REMOVE_ORG_COORDINATOR_FAIL =
  'dofe-bo/MY_ORGANIZATION/REMOVE_ORG_COORDINATOR_FAIL'

const LEAD_COORDINATOR = 'dofe-bo/MY_ORGANIZATION/LEAD_COORDINATOR'
const LEAD_COORDINATOR_SUCCESS =
  'dofe-bo/MY_ORGANIZATION/LEAD_COORDINATOR_SUCCESS'
const LEAD_COORDINATOR_FAIL = 'dofe-bo/MY_ORGANIZATION/LEAD_COORDINATOR_FAIL'

const EXPORT_ORGANIZATIONS_LIST =
  'dofe-bo/MY_ORGANIZATION/EXPORT_ORGANIZATIONS_LIST'
const EXPORT_ORGANIZATIONS_LIST_SUCCESS =
  'dofe-bo/MY_ORGANIZATION/EXPORT_ORGANIZATIONS_LIST_SUCCESS'
const EXPORT_ORGANIZATIONS_LIST_FAIL =
  'dofe-bo/MY_ORGANIZATION/EXPORT_ORGANIZATIONS_LIST_FAIL'

const ASSIGN_GOP = 'dofe-bo/MY_ORGANIZATION/ASSIGN_GOP'
const ASSIGN_GOP_SUCCESS = 'dofe-bo/MY_ORGANIZATION/ASSIGN_GOP_SUCCESS'
const ASSIGN_GOP_FAIL ='dofe-bo/MY_ORGANIZATION/ASSIGN_GOP_FAIL'

const UNASSIGN_GOP = 'dofe-bo/MY_ORGANIZATION/UNASSIGN_GOP'
const UNASSIGN_GOP_SUCCESS = 'dofe-bo/MY_ORGANIZATION/UNASSIGN_GOP_SUCCESS'
const UNASSIGN_GOP_FAIL ='dofe-bo/MY_ORGANIZATION/UNASSIGN_GOP_FAIL'

const GET_AVAILABLE_GOP = 'dofe-bo/MY_ORGANIZATION/GET_AVAILABLE_GOP'
const GET_AVAILABLE_GOP_SUCCESS = 'dofe-bo/MY_ORGANIZATION/GET_AVAILABLE_GOP_SUCCESS'
const GET_AVAILABLE_GOP_FAIL ='dofe-bo/MY_ORGANIZATION/GET_AVAILABLE_GOP_FAIL'

const GET_GOP_LIST = 'dofe-bo/MY_ORGANIZATION/GET_GOP_LIST'
const GET_GOP_LIST_SUCCESS = 'dofe-bo/MY_ORGANIZATION/GET_GOP_LIST_SUCCESS'
const GET_GOP_LIST_FAIL ='dofe-bo/MY_ORGANIZATION/GET_GOP_LIST_FAIL'

const GET_SGOP_LIST = 'dofe-bo/MY_ORGANIZATION/GET_SGOP_LIST'
const GET_SGOP_LIST_SUCCESS = 'dofe-bo/MY_ORGANIZATION/GET_SGOP_LIST_SUCCESS'
const GET_SGOP_LIST_FAIL ='dofe-bo/MY_ORGANIZATION/GET_SGOP_LIST_FAIL'


const GET_SUB_GOP = 'dofe-bo/MY_ORGANIZATION/GET_SUB_GOP'
const GET_SUB_GOP_SUCCESS = 'dofe-bo/MY_ORGANIZATION/GET_SUB_GOP_SUCCESS'
const GET_SUB_GOP_FAIL ='dofe-bo/MY_ORGANIZATION/GET_SUB_GOP_FAIL'

const CHECK_UNIT = 'dofe-bo/UNIT/CHECK_UNIT'
const CHECK_UNIT_SUCCESS = 'dofe-bo/UNIT/CHECK_UNIT_SUCCESS'
const CHECK_UNIT_FAIL = 'dofe-bo/UNIT/CHECK_UNIT_FAIL'
const SET_FILTER = 'dofe-bo/UNIT/SET_FILTER'
const SET_ORGANIZATIONS_FILTER = 'dofe-bo/UNIT/SET_ORGANIZATIONS_FILTER'
const SET_PARAMS = 'dofe-bo/UNIT/SET_PARAMS'
const SET_CONTACT_PARAMS = 'dofe-bo/UNIT/SET_CONTACT_PARAMS'
const REMOVE_DETAIL_DATA = 'dofe-bo/UNIT/REMOVE_DETAIL_DATA'
const SET_DISABLED_CACHE = 'dofe-bo/UNIT/SET_DISABLED_CACHE'
const SET_INITIAL_PARAMS = 'dofe-bo/UNIT/SET_INITIAL_PARAMS'

const SET_ORGANIZATIONS_LIST_SELECTED = 'dofe-bo/MY_ORGANIZATION/SET_ORGANIZATIONS_LIST_SELECTED'
const TOGGLE_ORGANIZATIONS_ALL_SELECTED = 'dofe-bo/MY_ORGANIZATION/TOGGLE_ORGANIZATIONS_ALL_SELECTED'
const BULK_ORGANIZATIONS_RESET = 'dofe-bo/MY_ORGANIZATION/BULK_ORGANIZATIONS_RESET'

const GET_ORG_CLIENT_CUSTOMIZATION = 'dofe-bo/ORGANIZATIONS/GET_ORG_CLIENT_CUSTOMIZATION'
const GET_ORG_CLIENT_CUSTOMIZATION_SUCCESS = `dofe-bo/ORGANIZATIONS/GET_ORG_CLIENT_CUSTOMIZATION_SUCCESS`
const GET_ORG_CLIENT_CUSTOMIZATION_FAIL = `dofe-bo/ORGANIZATIONS/GET_ORG_CLIENT_CUSTOMIZATION_FAILN`

const initialState = {
  list: [],
  listAUs: [],
  listIACs: [],
  listNAOs: [],
  listICs: [],
  listOAs: [],
  listSOAs: [],
  listROs: [],
  listGOPs: [],
  listSGOPs: [],
  listGOPOrgStructure: [],
  codeList: [],
  codeListAUs: [],
  codeListIACs: [],
  codeListNAOs: [],
  codeListICs: [],
  codeListOAs: [],
  codeListSOAs: [],
  codeListROs: [],
  detail: {},
  sort: '',
  offset: 0,
  limit: 10,
  pages: 1,
  count: null,
  filter: '',
  invalidate: null,
  loading: false,
  loaded: false,
  gops: {
    removing: false,
    removed: false,
  },
  leaders: {
    list: [],
    loading: false,
    loaded: false,
    sort: '',
    offset: 0,
    limit: 1,
    pages: 1,
    count: null,
    filter: '',
    invalidate: null
  },
  selectedIds: [],
  bulk: {
    loading: false,
    loaded: false
  },
  customization: {}
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case GET_UNITS_LIST:
      return {
        ...state,
        loading: !action.silentLoading,
        list: []
      }
    case GET_UNITS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        listAUs: getOrgsHierarchyId(action.baseFilter) ==
        ORGANIZATION_HIERARCHY.AU.id
          ? action.result
          : state.listAUs,
        listIACs: getOrgsHierarchyId(action.baseFilter) ==
        ORGANIZATION_HIERARCHY.IAC.id
          ? action.result
          : state.listIACs,
        listNAOs: getOrgsHierarchyId(action.baseFilter) ==
        ORGANIZATION_HIERARCHY.NAO.id
          ? action.result
          : state.listNAOs,
        listICs: getOrgsHierarchyId(action.baseFilter) ==
        ORGANIZATION_HIERARCHY.IC.id
          ? action.result
          : state.listICs,
        listROs: getOrgsHierarchyId(action.baseFilter) ==
        ORGANIZATION_HIERARCHY.RO.id
          ? action.result
          : state.listROs,
        listSOAs: getOrgsHierarchyId(action.baseFilter) ==
        ORGANIZATION_HIERARCHY.SOA.id
          ? action.result
          : state.listSOAs,
        listOAs: getOrgsHierarchyId(action.baseFilter) ==
        ORGANIZATION_HIERARCHY.OA.id
          ? action.result
          : state.listOAs,
        listGOPs: getOrgsHierarchyId(action.baseFilter) ==
        ORGANIZATION_HIERARCHY.GOP.id
            ? action.result
            : state.listGOPs,
        listSGOPs: getOrgsHierarchyId(action.baseFilter) ==
        ORGANIZATION_HIERARCHY.SGOP.id
            ? action.result
            : state.listSGOPs,
        listGOPOrgStructure: action.baseFilter == `or(hierarchyLevel.value=${ORGANIZATION_HIERARCHY.SGOP.value},hierarchyLevel.value=${ORGANIZATION_HIERARCHY.GOP.value})`
            ? action.result
            : state.listGOPOrgStructure,
        list: action.result,
        count: !action.ignoreCount
          ? Number(action.headers['x-total-count'])
          : state.count,
        pages: !action.ignorePage
          ? Math.ceil(Number(action.headers['x-total-count']) / state.limit) ||
          state.pages
          : state.pages
      }

    case GET_UNITS_LIST_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_UNITS_CODE_LIST:
      return {
        ...state,
        loading: true,
        codeList: []
      }
    case GET_UNITS_CODE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        codeListAUs: getOrgsHierarchyId(action.filter) ==
        ORGANIZATION_HIERARCHY.AU.id
          ? action.result
          : state.codeListAUs,
        codeListIACs: getOrgsHierarchyId(action.filter) ==
        ORGANIZATION_HIERARCHY.IAC.id
          ? action.result
          : state.codeListIACs,
        codeListNAOs: getOrgsHierarchyId(action.filter) ==
        ORGANIZATION_HIERARCHY.NAO.id
          ? action.result
          : state.codeListNAOs,
        codeListICs: getOrgsHierarchyId(action.filter) ==
        ORGANIZATION_HIERARCHY.IC.id
          ? action.result
          : state.codeListICs,
        codeListROs: getOrgsHierarchyId(action.filter) ==
        ORGANIZATION_HIERARCHY.RO.id
          ? action.result
          : state.codeListROs,
        codeListSOAs: getOrgsHierarchyId(action.filter) ==
        ORGANIZATION_HIERARCHY.SOA.id
          ? action.result
          : state.codeListSOAs,
        codeListOAs: getOrgsHierarchyId(action.filter) ==
        ORGANIZATION_HIERARCHY.OA.id
          ? action.result
          : state.codeListOAs,
        codeList: action.result
      }
    case GET_UNITS_CODE_LIST_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }

    case APPROVE_AWARD_UNIT:
      return {
        ...state,
        loading: true
      }
    case APPROVE_AWARD_UNIT_SUCCESS:
      return {
        ...state,
        loading: false,
        detail: action.result
      }
    case APPROVE_AWARD_UNIT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }

    case GET_UNIT:
      return {
        ...state,
        loading: true
      }
    case GET_UNIT_SUCCESS:
      return {
        ...state,
        loading: false,
        detail: action.result
      }
    case GET_UNIT_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case ASSIGN_GOP:
      return {
        ...state,
        loading: true
      }
    case ASSIGN_GOP_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case ASSIGN_GOP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case UNASSIGN_GOP:
      return {
        ...state,
        gops: {
          removing: true
        }
      }
    case UNASSIGN_GOP_SUCCESS:
      return {
        ...state,
        gops: {
          removing: false,
          removed: true
        }
      }
    case UNASSIGN_GOP_FAIL:
      return {
        ...state,
        gops: {
          removing: false
        },
        error: action.error
      }
    case GET_AVAILABLE_GOP:
      return {
        ...state,
        loading: true
      }
    case GET_AVAILABLE_GOP_SUCCESS:
      return {
        ...state,
        loading: false,
        listGOPs: action.result
      }
    case GET_AVAILABLE_GOP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case GET_SUB_GOP:
      return {
        ...state,
        loading: true
      }
    case GET_SUB_GOP_SUCCESS:
      return {
        ...state,
        loading: false,
        listSGOPs: action.result
      }
    case GET_SUB_GOP_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case GET_GOP_LIST:
      return {
        ...state,
        loading: true
      }
    case GET_GOP_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        listGOPs: action.result
      }
    case GET_GOP_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case GET_SGOP_LIST:
      return {
        ...state,
        loading: true
      }
    case GET_SGOP_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        listSGOPs: action.result
      }
    case GET_SGOP_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case UPDATE_MY_ORGANIZATION:
      return {
        ...state,
        loading: true
      }
    case UPDATE_MY_ORGANIZATION_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case UPDATE_MY_ORGANIZATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case GET_MY_ORGANIZATION_LEADER:
      return {
        ...state,
        leaders: {
          ...state.leaders,
          loading: true
        }
      }
    // LEADER === ORGANIZATION CONTACT
    case GET_MY_ORGANIZATION_LEADER_SUCCESS:
      return {
        ...state,
        leaders: {
          ...state.leaders,
          list: action.result,
          loading: false,
          loaded: true,
          count: action.headers['x-total-count'],
          pages: Math.ceil(
            Number(action.headers['x-total-count']) / state.leaders.limit
          ) || state.leaders.pages
        }
      }
    case GET_MY_ORGANIZATION_LEADER_FAIL:
      return {
        ...state,
        leaders: {
          ...state.leaders,
          loading: false
        },
        error: action.error
      }
    case SET_ORGANIZATIONS_FILTER:
      return Object.assign({}, state, {
        filter: action.filterBy,
        offset: 0,
        invalidate: new Date().getTime()
      })
    case SET_FILTER:
      return {
        ...initialState,
        ...state,
        leaders: {
          ...state.leaders,
          filter: action.filterBy,
          offset: 0,
          invalidate: new Date().getTime()
        }
      }
    case SET_PARAMS:
      return {
        ...state,
        limit: action.options.limit !== undefined
          ? action.options.limit
          : state.limit,
        offset: action.options.offset !== undefined
          ? action.options.offset
          : state.offset,
        filter: action.options.filter !== undefined
          ? action.options.filter
          : state.filter,
        sort: action.options.sort !== undefined
          ? action.options.sort
          : state.sort,
        invalidate: _.isEmpty(action.options)
          ? state.invalidate
          : new Date().getTime()
      }
    case SET_CONTACT_PARAMS:
      return {
        ...state,
        leaders: {
          ...state.leaders,
          limit: action.options.limit !== undefined
            ? action.options.limit
            : state.leaders.limit,
          offset: action.options.offset !== undefined
            ? action.options.offset
            : state.leaders.offset,
          filter: action.options.filter !== undefined
            ? action.options.filter
            : state.leaders.filter,
          sort: action.options.sort !== undefined
            ? action.options.sort
            : state.leaders.sort,
          invalidate: _.isEmpty(action.options)
            ? state.leaders.invalidate
            : new Date().getTime()
        }
      }
    case SET_INITIAL_PARAMS:
      return {
        ...state,
        offset: 0,
        limit: 10,
        pages: 1,
        filter: '',
        invalidate: null,
        loading: false,
        loaded: false
      }
    case SET_ORGANIZATIONS_LIST_SELECTED:
      return {
        ...state,
        selectedIds: action.bulkType
            ? intersection(action.selectedIds,
                mapForBulk(state.list || [], action.bulkType))
            : action.selectedIds
      }
    case TOGGLE_ORGANIZATIONS_ALL_SELECTED:
      if (sameIdsIn(action.selectedIds, action.selectableIds)) {
        return {
          ...state,
          selectedIds: []
        }
      }

      return {
        ...state,
        selectedIds: [...action.selectableIds]
      }
    case BULK_ORGANIZATIONS_RESET:
      return {
        ...state,
        bulk: {
          loading: false,
          loaded: false
        }
      }
    case GET_ORG_CLIENT_CUSTOMIZATION:
      return {
        ...state,
        loading: true
      }
    case GET_ORG_CLIENT_CUSTOMIZATION_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        customization: action.result || {}
      }
    case GET_ORG_CLIENT_CUSTOMIZATION_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    default:
      return state
  }
}

export function getOrganizations (
  params = {},
  baseFilter = '',
  queryParams = {},
  {
    isMinimal = false,
    disableLimit = false,
    disablePaging = false,
    includeInactive = false,
    silentLoading = false,
    ignoreCount = false,
    ignorePage = false,
    resetFilter = false,
    assessor = false
  } = {}
) {
  const shouldFetchInactive = params.filter ? true : includeInactive
  let modifiedParams = params
  let readParams = `?with=LABELS,LABELS_ORGANIZATION_DETAIL,AUTHORIZING_CONTACT,ORGANIZATION_DETAIL,REGION,PARENT,PARENT_NAO,PARENT_OA,COUNTRY,COORDINATORS${queryParams.params || ''}`

  if (queryParams.disableRootQueryParams) {
    readParams = readParams = `?with=${queryParams.params || ''}`
  }

  if (isMinimal) {
    readParams = `?with=ID,NAME${queryParams.params || ''}`
  }

  if (disableLimit) {
    modifiedParams = {
      ...modifiedParams,
      limit: undefined
    }
  }

  if (disablePaging) {
    modifiedParams = {
      ...modifiedParams,
      offset: 0
    }
  }

  if (resetFilter) {
    modifiedParams = {
      ...modifiedParams,
      filter: ''
    }
  }


  return {
    types: [GET_UNITS_LIST, GET_UNITS_LIST_SUCCESS, GET_UNITS_LIST_FAIL],
    baseFilter,
    silentLoading,
    ignoreCount,
    ignorePage,
    promise: client =>
      client.get(
        `api/organizations${readParams}${routeParams(modifiedParams, baseFilter)}&sort=+name&includeInactive=${shouldFetchInactive}&assessor=${assessor}`
      )
  }
}

export function getOrganization (id, queryParams) {
  const query = `AUTHORIZING_CONTACT,FINANCIAL_DATA,COORDINATORS,ORGANIZATION_DETAIL,SHIPPING_ADDRESS,BILLING_ADDRESS,PARENT_REGION,PARENT_NAO,PARENT_GOP,PARENT_SGOP,PARENT_IC,PARENT_OA,PARENT_SUBOA,${queryParams}`

  return {
    types: [GET_UNIT, GET_UNIT_SUCCESS, GET_UNIT_FAIL],
    promise: client => client.get(`api/organizations/${id}?with=${query}`)
  }
}

export function getOrganizationCodeList (filter = '') {

  return {
    types: [GET_UNITS_CODE_LIST, GET_UNITS_CODE_LIST_SUCCESS, GET_UNITS_CODE_LIST_FAIL],
    filter,
    promise: client => client.get(`api/code-list/organizations?filter=${filter}&sort=+name&organizationState.value=ACTIVE`)
  }
}

export function checkOrganization (name, countryId = 1) {
  return {
    types: [CHECK_UNIT, CHECK_UNIT_SUCCESS, CHECK_UNIT_FAIL],
    promise: client =>
      client.get(
        `api/registration/organizations?eventName=${encodeURI(name)}&countryId=${countryId}`,
        {
          removeToken: true
        }
      )
  }
}

export function approveAwardUnit (id, data) {
  return {
    types: [
      APPROVE_AWARD_UNIT,
      APPROVE_AWARD_UNIT_SUCCESS,
      APPROVE_AWARD_UNIT_FAIL
    ],
    promise: client =>
      client.post(`api/award-unit-registration-approval/${id}`, {
        data
      })
  }
}

export function getOrganizationLeaders (id, params = {}, baseFilter) {

  return {
    types: [
      GET_MY_ORGANIZATION_LEADER,
      GET_MY_ORGANIZATION_LEADER_SUCCESS,
      GET_MY_ORGANIZATION_LEADER_FAIL
    ],
    promise: client =>
      client.get(
        `api/organizations/${id}/leaders?getCurrentUserFirst=true&with=PERSON${routeParams(params, baseFilter)}`
      )
  }
}

export function changeOrganizationAuthorizingContact (orgId, orgContactId) {
  return {
    types: [
      CHANGE_ORG_AUTH_CONTACT,
      CHANGE_ORG_AUTH_CONTACT_SUCCESS,
      CHANGE_ORG_AUTH_CONTACT_FAIL
    ],
    promise: client =>
      client.post(
        `api/organizations/${orgId}/authorizing-contacts/${orgContactId}`
      )
  }
}

export function changeOrganizationCoordinator (orgId, orgContactId) {
  return {
    types: [
      CHANGE_ORG_COORDINATOR,
      CHANGE_ORG_COORDINATOR_SUCCESS,
      CHANGE_ORG_COORDINATOR_FAIL
    ],
    promise: client =>
      client.post(`api/organizations/${orgId}/coordinators/${orgContactId}`)
  }
}

export function removeOrganizationCoordinator (orgId, orgContactId) {
  return {
    types: [
      REMOVE_ORG_COORDINATOR,
      REMOVE_ORG_COORDINATOR_SUCCESS,
      REMOVE_ORG_COORDINATOR_FAIL
    ],
    promise: client =>
      client.del(`api/organizations/${orgId}/coordinators/${orgContactId}`)
  }
}




export function updateMyOrganization (
  id,
  data,
  update = '',
  { removeDefaultParams = false } = {}
) {
  let queryUpdateParams = `ORGANIZATION_DETAIL,SHIPPING_ADDRESS,BILLING_ADDRESS${update ? `,${update}` : ''}`

  if (removeDefaultParams) {
    queryUpdateParams = update
  }

  return {
    types: [
      UPDATE_MY_ORGANIZATION,
      UPDATE_MY_ORGANIZATION_SUCCESS,
      UPDATE_MY_ORGANIZATION_FAIL
    ],
    promise: client =>
      client.put(`api/organizations/${id}?update=${queryUpdateParams}`, {
        data
      })
  }
}

export function removeOrganization (id) {
  return {
    types: [
      REMOVE_ORGANIZATION,
      REMOVE_ORGANIZATION_SUCCESS,
      REMOVE_ORGANIZATION_FAIL
    ],
    promise: client => client.del(`api/organizations/${id}`)
  }
}

export function makeLeadCoordinator (
  contactId,
  organisationId,
  { isLeadCoordinator = false } = {}
) {
  return {
    types: [LEAD_COORDINATOR, LEAD_COORDINATOR_SUCCESS, LEAD_COORDINATOR_FAIL],
    promise: client =>
      client.post(
        `api/organizations/${organisationId}/lead-coordinator/${contactId}`,
        {
          value: isLeadCoordinator
        }
      )
  }
}

export function exportOrganizations (params = {}, baseFilter) {

  const paramsFilter = (params.filter && params.filter.includes('INACTIVE')) ? params.filter + '&includeInactive=true': params.filter

  return {
    types: [
      EXPORT_ORGANIZATIONS_LIST,
      EXPORT_ORGANIZATIONS_LIST_SUCCESS,
      EXPORT_ORGANIZATIONS_LIST_FAIL
    ],
    promise: client =>
      client.get(
        `api/organizations?with=LABELS,LABELS_ORGANIZATION_DETAIL,AUTHORIZING_CONTACT,ORGANIZATION_DETAIL,REGION,PARENT,PARENT_NAO,PARENT_OA,COUNTRY,COORDINATORS${routeParams({ filter: paramsFilter }, baseFilter)}`
      )
  }
}

export function changeOrganisationMode (orgId, data) {
  return {
    types: [
      CHANGE_ORGANIZATION_MODE,
      CHANGE_ORGANIZATION_MODE_SUCCESS,
      CHANGE_ORGANIZATION_MODE_FAIL
    ],
    promise: client =>
      client.put(`api/organizations/${orgId}?update=CHANGE_ORGANIZATION_MODE`, {
        data
      })
  }
}

export function setOrganizationsFilter (filterBy) {
  return {
    type: SET_ORGANIZATIONS_FILTER,
    filterBy
  }
}

export function setMyOrganizationContactsFilter (filterBy) {
  return {
    type: SET_FILTER,
    filterBy
  }
}

export function removeMyOrganizationContactsDetailData () {
  return {
    type: REMOVE_DETAIL_DATA
  }
}

export function removeMyOrganizationContactsCache () {
  return {
    type: SET_DISABLED_CACHE
  }
}

export function setInitialParams () {
  return {
    type: SET_INITIAL_PARAMS
  }
}

export function setOrganizationsParams (options) {
  return {
    type: SET_PARAMS,
    options
  }
}

export function setOrganizationContactsParams (options) {
  return {
    type: SET_CONTACT_PARAMS,
    options
  }
}

export function assignGlobalOperatingPartner(orgId, gopId, sgopId) {
  const data = { sgopId }

  return {
    types: [
      ASSIGN_GOP,
      ASSIGN_GOP_SUCCESS,
      ASSIGN_GOP_FAIL
    ],
    promise: client => client.post(`api/organizations/${orgId}/gop/assign/${gopId}`, {data})
  }
}

export function setGlobalOperatingPartnerToOrgRegistration(awardUnitRegistrationId, gopId, sgopId) {
  const data = { gopId, sgopId }

  return {
    types: [
      ASSIGN_GOP,
      ASSIGN_GOP_SUCCESS,
      ASSIGN_GOP_FAIL
    ],
    promise: client => client.post(`api/award-unit-registration/${awardUnitRegistrationId}/gop/set`, {data})
  }
}

export function unassignGlobalOperatingPartner(orgId) {
  return {
    types: [
      UNASSIGN_GOP,
      UNASSIGN_GOP_SUCCESS,
      UNASSIGN_GOP_FAIL
    ],
    promise: client => client.post(`api/organizations/${orgId}/gop/unassign`, {})
  }
}

export function getAvailableGlobalOperatingPartner(orgId) {
  return {
    types: [
      GET_AVAILABLE_GOP,
      GET_AVAILABLE_GOP_SUCCESS,
      GET_AVAILABLE_GOP_FAIL
    ],
    promise: client => client.get(`api/organizations/${orgId}/gop/available`, {})
  }
}

export function getGlobalOperatingPartnerList() {
  return {
    types: [
      GET_GOP_LIST,
      GET_GOP_LIST_SUCCESS,
      GET_GOP_LIST_FAIL
    ],
    promise: client => client.get(`api/organizations/gop/list`, {})
  }
}


export function getSubGlobalOperatingPartnerList(gopId) {
  return {
    types: [
      GET_SGOP_LIST,
      GET_SGOP_LIST_SUCCESS,
      GET_SGOP_LIST_FAIL
    ],
    promise: client => client.get(`api/organizations/gop/${gopId}/sgop/list`, {})
  }
}



export function getSubGlobalOperatingPartner(orgId, gopId) {
  return {
    types: [
      GET_SUB_GOP,
      GET_SUB_GOP_SUCCESS,
      GET_SUB_GOP_FAIL
    ],
    promise: client => client.get(`api/organizations/${orgId}/gop/${gopId}/sub-gop`, {})
  }
}

export function setOrganizationsSelected(selectedIds, bulkType) {
  return {
    type: SET_ORGANIZATIONS_LIST_SELECTED,
    selectedIds,
    bulkType
  }
}

export function toggleOrganizationsAllSelected(selectedIds, selectableIds) {
  return {
    type: TOGGLE_ORGANIZATIONS_ALL_SELECTED,
    selectedIds,
    selectableIds
  }
}

export function bulkOrganizationsReset() {
  return {
    type: BULK_ORGANIZATIONS_RESET
  }
}

export function getOrganizationClientCustomization (id) {
  return {
    types: [GET_ORG_CLIENT_CUSTOMIZATION, GET_ORG_CLIENT_CUSTOMIZATION_SUCCESS, GET_ORG_CLIENT_CUSTOMIZATION_FAIL],
    promise: client =>
      client.get(
        `api/organization-client-customization/home-page/${id}/get`,
        {
          removeToken: true
        }
      )
  }
}

/* eslint-enable */
